import { getIsOnlineHealthCheckerApi } from '@/accessors/api/requests/disasterCommonHealthCheckerApiGwFuncs'

/**
 * オンラインかどうかを外部APIに接続して取得する
 * @returns {Promise<boolean>} オンラインかどうか
 */
export const isOnlineByHealthChecker = async (): Promise<boolean> => {
  return await getIsOnlineHealthCheckerApi()
    .then(res => {
      // レスポンスにエラーがなければオンラインと判定する
      return res.error === undefined
    })
    .catch(() => {
      return false
    })
}
